<template>
  <div class="layout-menu-card-header">
    <div class="header-content-left">
      <div class="header-title">常用模块</div>
      <UserAccess
        ref="userAccess"
        v-if="showUserAccess"
        :isShowComment="false"
      />
    </div>
    <div class="header-content-right">
      <el-button class="fr" type="text" @click="showMenuDialog">
        <img src="../images/tjcy.svg" style="transform: translateY(1px)" />
        添加常用
      </el-button>
      <el-button class="fr" type="text" @click="showGroupDialog">
        <img src="../images/group.svg" style="transform: translateY(1px)"/>
        分组管理
      </el-button>
    </div>
  </div>
</template>

<script>
  // 用户评价
  import UserAccess from '@/public/components/query-table/user-access'
  export default {
    data() {
      return {
        showUserAccess: false
      }
    },
    components: { UserAccess },
    mounted () {
      this.$bus.$once('APP_LOADED', this.init)
      if (window.__APP_LOADED__ === true) {
        this.showUserAccess = true
      }
    },
    methods: {
      init () {
        this.showUserAccess = true
      },
      showMenuDialog () {
        this.$emit('showMenuDialog')
      },
      showGroupDialog () {
        this.$emit('showGroupDialog')
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-card-header {
  padding: 8px 16px;
  height: 45px;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
  .header-content-left {
    display: flex;
    align-items: center;
    .header-title {
      font-size: 16px;
      font-weight: bolder;
    }
  }
  .header-content-right {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/card-header.vue